<template>
  <div class="ffootter" style="position: fixed; bottom: 0px; width:100%; background:#f8f8f8; border: 1px solid #e7e7e7;">
    <div class="container">
      <div class="row">
        <div class="col-md-3 text-left" style="padding: 10px 0;">
          <img style="max-height: 30px;max-width: 100%;" :src="config.url + config.img_url + config.id + '/' + state.info.logo">
        </div>
        <div class="col-md-6 text-center">
          <div class="store" v-if="state.info.android">
            <a :href="state.info.android" target="_blank"><img :src="config.url + 'images/googlePlay.png'" height="42px" alt="Загрузите в AppStore"></a>
          </div>
          <div class="social" v-if="state.info.instagram">
            <a style="color:#fff;" target="_blank" :href="state.info.instagram">
              <i class="fab fa-instagram"></i>
            </a>
          </div>
          <div class="social" v-if="state.info.vk">
            <a style="color:#fff;" target="_blank" :href="state.info.vk">
              <i class="fab fa-vk"></i>
            </a>
          </div>
          <div class="social" v-if="state.info.flamp">
            <a style="color:#fff;" target="_blank" :href="state.info.flamp">
              FL
            </a>
          </div>
          <div class="store" v-if="state.info.ios">
            <a :href="state.info.ios" target="_blank"><img :src="config.url + 'images/appStore.png'" height="42px"  alt="Загрузите в AppStore"></a>
          </div>
        </div>
        <div class="col-md-3 text-right" style="padding: 10px 0;">
          <p style="margin: 0">Сделано в <a href="http://buyhunter.ru/" target="_blank">BuyHunter.ru</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      config() {
        return this.$store.state.config
      },
      state() {
        return this.$store.state
      },
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/footer.vue